import {
  EqlFieldsAutoComplete,
  EqlFieldsAutoCompleteProps,
} from '@modules/common/components/EqlFieldsAutoComplete/EqlFieldsAutoComplete';
import { EqlField, EqlFieldValue } from 'generated/graphql';
import { SyntheticEvent } from 'react';

interface EqlFieldFiltersAutoCompleteProps
  extends Omit<EqlFieldsAutoCompleteProps, 'options' | 'onChange'> {
  groupID: string;
  onChange: (params: {
    eqlField: EqlField;
    eqlFieldValue?: EqlFieldValue;
  }) => void;
  getOptionDisplayName?: (option: EqlField) => string;
}

export function EqlFieldFiltersAutoComplete({
  groupID,
  onChange,
  getOptionDisplayName,
  ...props
}: EqlFieldFiltersAutoCompleteProps) {
  const onFieldChange = (eve: SyntheticEvent, eqlField: EqlField | null) => {
    if (!eqlField) {
      return;
    }
    onChange({ eqlField });
  };

  return (
    <EqlFieldsAutoComplete
      onChange={onFieldChange}
      groupID={groupID}
      getOptionDisplayName={getOptionDisplayName}
      {...props}
    />
  );
}
